export const scenario = {
  addScenario: "シナリオの追加",
  addMappingSuccess: "メッセージグループがマッピングされました",
  deleteMappingSuccess: "マッピングが削除されました",
};
